<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single singleItem container-flex page-content">

        <!--  Loading Animation when changing variation / add to basket -->
        <div v-if="$store.state.items.isAddToBasketLoading != 0" class="item-loading-splash-screen">
          <icon icon="spinner" :loading="$store.state.items.isAddToBasketLoading != 0"></icon>
        </div>

        <div class="bg-white">
          <div class="singleItemGrid">

            <slot name="breadcrumb"></slot>

            <div class="singleItemName">
              <h1 v-html="currentVariation.texts.name1"></h1>
              <div class="feedbackTags">
                <client-only>
                  <feedback-average
                          class="box-feedback"
                          :show-empty-ratings="false"
                          size-of-stars="small"
                          :show-ratings-amount="true">
                  </feedback-average>
                </client-only>

                <span class="tag tagFavorit" v-if="hasPropertySelection(166, 397)">Bestseller</span>
                <template v-for="tag in currentVariation.tags" v-if="[130, 131, 132, 133].includes(tag.id)">
                  <span target="#sizeTable" :class="'scrollTo tag tagSize' + (parseInt(tag.id) - 129)"
                    v-html="tag.names.name"></span>
                </template>
              </div>

              <bkAddToWishlist class="bkcc" :variation-id="currentVariation.variation.id"></bkAddToWishlist>
            </div>

            <div class="singleItemImage text-center mb-2">
              <slot name="image-carousel"></slot>

              <!-- Video Modal -->
              <template v-for="property in getProperty(192)">
                <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="Youtube Video"
                  aria-hidden="true">
                  <div class="modal-dialog">
                      <div class="modal-content">
                      <div class="modal-body">
                        <iframe id="ytplayer" type="text/html" width="100%" height="400px"
                          :src="'https://www.youtube.com/embed/' + property.values.value + '?autoplay=0&modestbranding=1'"
                          frameborder="0"></iframe>
                      </div>
                    </div>
                  </div>
                </div><!-- ./ Modal 
              -->
              </template>

              <!-- Open in Laura CubeConfig -->
              <a v-if="cubeConfigLink" 
                :href="cubeConfigLink" 
                class="openLauraPlanner btn-sm btn-bkm-inverted btn" 
                v-html="$translate('biokinderDesign::Template.openSetInPlanner')"></a>
            </div>

            <div class="singleItemDetails single-rightside mb-2">
              
              <slot name="admin-form-cartcross"></slot>

              <!-- 
              <share
                :title="currentVariation.texts.name1 + $translate('biokinderDesign::Template.shareTitleSuffix')">
              </share> -->

              <div><!-- v-stick-in-parent -->

                <div :class="'availabilityRow availabilityRow_' + currentVariation.variation.availability.id">
                  <biokinder-availability :avd="$attrs.availabilitydata"
                    :variation="currentVariation.variation"></biokinder-availability>
                </div>

                <!-- Variation -->
                <div class="variationSelect" v-if="attributes.length || (currentVariation.filter.isSalable && variationGroupedProperties.length)">
                  <variation-select></variation-select>
                  
                  <!-- ORDER PROPERTIES -->
                  <div class="orderProperties" v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                    <order-property-list></order-property-list>
                    <slot name="aufbauservice"></slot>
                  </div>
                </div>
                <!-- /Variation -->

                <slot name="before-price"></slot>

                <div class="singleartprice mb-3" itemprop="offerDetails" itemscope=""
                  itemtype="http://data-vocabulary.org/Offer">
                  <span data-toggle="collapse" aria-expanded="false" class="variationManufacturer"
                    data-target="#manufacturer">
                    <img v-if="currentVariation.item.manufacturer.id && currentVariation.item.manufacturer.logo"
                      :src="currentVariation.item.manufacturer.logo"
                      :alt="'Marken-Logo-' + currentVariation.item.manufacturer.externalName" />
                  </span>
                  <div class="variationPrice">
                    <graduated-prices></graduated-prices>
                    <item-price></item-price>
                    <input type="hidden" id="stdShippingCosts"
                      :value="currentVariation.variation.defaultShippingCosts" />

                    <slot
                      v-if="currentVariation.prices.default.price && currentVariation.prices.default.price.value > 200"
                      name="before-add-to-basket" class="mt-2"></slot>
                  </div>
                </div>

                <template v-if='showSalesCoupon'>
                  <client-only>
                    <sales-coupon 
                      :code="bkconfig.shopSale.coupon" 
                      :showvalid="false" 
                      :icon="(bkconfig.shopSale.showIconOnSingleItem === 'true')"
                      :moreinfo="'- ' + $options.filters.currency((currentVariation.prices.default.price.value * bkconfig.shopSale.singleItemFactor), currentVariation.prices.default.currency) + $translate('biokinderDesign::Sale.bkSaleSingleItemWithCode')"
                      :short="true" :details="true" :enddate="bkconfig.shopSale.enddate"
                      :countdown="bkconfig.shopSale.defaultCountdownText"
                      :countdown-position="bkconfig.shopSale.actionbar.countdownPosition"
                      :short-headline="bkconfig.shopSale.shortHeadline"></sales-coupon>
                  </client-only>
                </template>


                <add-to-basket :variation-id="currentVariation.variation.id"
                  :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                  :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                  :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                  :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                  :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                  :order-properties="currentVariation.properties.filter(function (prop) { return prop.property.isOderProperty })"
                  :use-large-scale="false" :show-quantity="true" :item-url="currentVariation | itemURL"
                  :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                  :has-price="currentVariation | hasItemDefaultPrice">
                </add-to-basket>

                <div>
                  <slide-content v-if="hasProperty(292) && crossSellingCategoryId > 0" :name="'crossselling'" :variation-id="currentVariation.variation.id" :category-id="crossSellingCategoryId"></slide-content>
                  <slide-content v-else-if="hasCartCrossSelling" 
                      :name="'crossselling'" 
                      :cart-cross-selling="true"
                      :variation-id="currentVariation.variation.id">
                        <template #content="{ isOpen }">
                          <async-item-list-loader
                            v-if="cartCrossSellingIds.length > 0"
                            type="cartCrossSelling"
                            :variation-ids="cartCrossSellingIds"
                            :decimal-count="crossSellingDecimalCount"
                            :is-active="isOpen">
                          </async-item-list-loader>
                        </template>
                  </slide-content>
                
                  <slot name="additional-content-after-add-to-basket"></slot>
                  <!-- Audioplayer -->
                  <div v-if="hasProperty(193)" class="audioPlayer" id="audioPlayerContainer">
                    <div v-for="prop in getProperty(193)" v-if="prop.values.value != ''" class='title'>
                      <span v-html="prop.values.value"></span>
                    </div>
                    <div class="button">
                      <i class="fa fa-play" id="playBtn"></i>
                      <i class="fa fa-undo" id="resetBtn"></i>
                    </div>
                    <div class="contents">
                      <div class="time">
                        <span class="elapsed" id="elapsedTime">0:00</span>
                        <span class="seperator">&nbsp;/&nbsp;</span>
                        <span class="totalLength" id="totalLength">0:00</span>
                      </div>
                    </div>
                    <div class="playLine">
                      <div class="playLineActive" id="playLineActive"></div>
                    </div>
                    <audio id="audioPlayer" v-for="prop in getProperty(194)" v-if="prop.values.value != ''">
                      <source :src="prop.values.value" type="audio/mp3">
                    </audio>
                  </div>

                  <slot name="beaver"></slot>

                </div>

                <div v-if="hasProperty(166)" class="siegelContainer">
                  <a v-if="hasPropertySelection(166, 346)" href="/textseiten/natuerliche-rohstoffe/"
                    alt="Natürliche Rohstoffe" aria-label="Natürliche Rohstoffe" click-count>
                    <img src="https://cdn.bio-kinder.de/frontend/seals/natural.svg" alt="Natürliche Rohstoffe" />
                  </a>
                  <a v-if="hasPropertySelection(166, 275)"
                    href="/textseiten/bio-erlenholzmoebel-kindermoebel-fuer-babys-und-kinder/"
                    aria-label="Bio-Erlenholz" alt="Bio-Erlenholz" click-count>
                    <img src="https://cdn.bio-kinder.de/frontend/seals/alderwood.svg" alt="100% Bio-Erlenholz" />
                  </a>

                  <img v-if="hasPropertySelection(166, 449)" src="https://cdn.bio-kinder.de/frontend/seals/oak.svg"
                    alt="Bio-Eichenholz" />

                  <a v-if="hasPropertySelection(166, 276)" href="/textseiten/bio-kiefernholz-von-bio-kinder/"
                    aria-label="Bio-Kiefernholz" alt="Bio-Kiefernholz" click-count>
                    <img src="https://cdn.bio-kinder.de/frontend/seals/pinewood.svg" alt="100% Bio-Kiefernholz" />
                  </a>
                  <a v-if="hasPropertySelection(166, 345)" href="/content/10-jahre-garantie/"
                    aria-label="Möbelgarantie" alt="Möbelgarantie" click-count>
                    <img src="https://cdn.bio-kinder.de/frontend/seals/guarantee.svg" alt="10 Jahre Möbel-Garantie" />
                  </a>
                  <a v-if="hasPropertySelection(166, 344)" href="/content/100-fair-produziert/"
                    aria-label="Fair produziert" alt="Fair produziert" click-count>
                    <img src="https://cdn.bio-kinder.de/frontend/seals/fair.svg" alt="Fair produziert" />
                  </a>
                  <img v-if="hasPropertySelection(166, 403)"
                    src="https://cdn.bio-kinder.de/frontend/seals/organictreewool.svg" alt="kbA Baumwolle" />
                  <img v-if="hasPropertySelection(166, 404)"
                    src="https://cdn.bio-kinder.de/frontend/seals/sheepwool.svg" alt="100% Schurwolle" />
                </div>

                <div v-if="hasProperty(166)" class="siegelContainer">
                  <img data-toggle="modal" class="bioolaLogo" data-target="#bioola"
                    v-if="hasPropertySelection(166, 274)"
                    src="https://cdn.bio-kinder.de/frontend/assets/bioola/bioola.svg" alt="bioola Lasur" />
                  <img class="softCloseLogo" v-if="hasPropertySelection(166, 622)"
                    src="https://cdn.bio-kinder.de/frontend/seals/soft_close.svg" alt="Soft-Close" />
                  <img v-if="hasPropertySelection(166, 617)"
                    src="https://cdn.bio-kinder.de/frontend/seals/din1729.svg" alt="DIN geprueft" />
                  <img style="max-height:80px" v-if="hasPropertySelection(166, 652)"
                    src="https://cdn.bio-kinder.de/frontend/images/icons/made_in_germany.svg"
                    alt="Hergestellt in Deutschland" />
                </div>

              </div><!--stick-end-->

            </div>
          </div>
        </div>

        <div class="container-max">
          <div class="row">
            <div class="col-md-7">
              <section class="descriptionContainer tmplt">
                <span class="containerHeading" v-html="$translate('Ceres::Template.singleItemDescription')"></span>
                <div class="descriptionContent" v-if="hasProperty(290)" v-html="getProperty(290)[0]?.values.value"></div>
                <div class="descriptionContent" v-else v-html="currentVariation.texts.description"></div>
              </section>
            </div>

            <aside class="col-md-5" id="rightSide">
              <section class="descriptionContainer shippingInfo">
                <biokinder-shipping-icon 
                :variation="currentVariation.variation" 
                :avd="$attrs.availabilitydata"
                :availability="currentVariation.variation.availabilityId" 
                :shipping="calcDefaultShippingCosts"
                :countryId="shippingCountryId"
                :freight-type="freightType"
                ></biokinder-shipping-icon>
              </section>

              <!-- instagram -->
              <template v-if="hasProperty(197)">
                <section class="descriptionContainer instagram">
                  <instagram-gallery :variation-id="currentVariation.variation.id" :caption="currentVariation.texts.name1"></instagram-gallery>
                </section>
              </template>


              <!-- Technical Data -->
              <section class="descriptionContainer">
                <div id="application">
                  <button class="btn btn-block text-left descriptionButton collapsed" data-toggle="collapse"
                    data-target="#applicationContainer" aria-expanded="false" aria-controls="applicationContainer"
                    aria-label="Technische Daten" click-count>
                    <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="1.5" fill="none"
                      stroke-linecap="round" stroke-linejoin="round" class="icon-technicaldata">
                      <circle cx="12" cy="12" r="3"></circle>
                      <path
                        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                      </path>
                    </svg>
                    <span v-html="$translate('Ceres::Template.singleItemTechnicalData')"></span>
                    <i data-feather="plus"></i>
                  </button>
                </div>
                <div id="applicationContainer" class="collapse" aria-labelledby="more_details" data-parent="#rightSide">
                  <div class="descriptionContent">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <th>Artikelnummer</th>
                          <td>{{ currentVariation.item.id }}-{{ currentVariation.variation.id }}</td>
                        </tr>
                        <tr
                          v-if="currentVariation.filter.hasManufacturer && currentVariation.item.manufacturer.externalName !== ''">
                          <th>{{ $translate("Ceres::Template.singleItemManufacturer") }}</th>
                          <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                        </tr>
                        <tr v-if="currentVariation.variation.weightG > 0">
                          <th>Gewicht</th>
                          <td>ca. {{ (currentVariation.variation.weightG / 1000) | numberFormat(2, ',') }} kg</td>
                        </tr>
                        <tr>
                          <th>Pakete</th>
                          <td v-if="currentVariation.variation.packingUnits > 0">{{
                            currentVariation.variation.packingUnits }}</td>
                          <td v-else>1</td>
                        </tr>
                        <template v-if="techProperties.length > 0">
                          <tr v-for="vProperty in techProperties">
                            <th>{{ vProperty.name }}</th>
                            <td>{{ vProperty.value }}</td>
                          </tr>
                        </template>
                        <tr v-if="hasPropertySelection(166, 393)">
                          <th>Vegan</th>
                          <td>Ja</td>
                        </tr>
                      </tbody>
                    </table>

                    <div v-html="currentVariation.texts.technicalData"></div>

                    <slot name="gpsr" v-if="showResponsible && !showManufacturer"></slot>
                  </div>
                </div>
              </section>

              <!-- Manufacturer -->
              <section id="manufacturerDetail" class="descriptionContainer"
                v-if="showManufacturer">
                <button class="btn btn-block text-left descriptionButton collapsed" data-toggle="collapse"
                  data-target="#manufacturer" aria-expanded="false" aria-controls="manufacturer"
                  :aria-label="'Hersteller-Details: ' + currentVariation.item.manufacturer.externalName" click-count>
                  <img :src="currentVariation.item.manufacturer.logo"
                    :alt="'Marken-Logo-' + currentVariation.item.manufacturer.externalName" />
                  <span v-html="currentVariation.item.manufacturer.externalName"></span>
                  <i data-feather="plus"></i>
                </button>

                <div id="manufacturer" class="collapse mt-1" aria-labelledby="manufacturer" data-parent="#rightSide">
                  <img :src="currentVariation.item.manufacturer.logo" :alt="'Logo ' + currentVariation.item.manufacturer.externalName" />
                  <div v-html="currentVariation.item.manufacturer.comment"></div>
                  <a :href="'/markenwelt/' + currentVariation.item.manufacturer.url + '-' + currentVariation.item.manufacturer.id + '/'"
                    class="btn btn-block btn-sm btn-bkm"
                    :aria-label="'Mehr Artikel von ' + currentVariation.item.manufacturer.externalName"
                    click-count>Weiteres Sortiment entdecken <i data-feather="chevron-right"></i></a>
                    <slot name="gpsr" v-if="showResponsible"></slot>
                </div>
              </section>

              <!-- Accessories -->
              <async-item-list-loader
                v-if="hasAccessoryCrossSelling"
                type="accessories"
                :item-id="itemId"
                :decimal-count="crossSellingDecimalCount">
              </async-item-list-loader>

              <!-- Bundle -->
              <template v-if="showBundleComponents">
                <single-item-bundle-details :variation-id="currentVariation.variation.id"></single-item-bundle-details>
              </template>

              <!-- Care -->
              <template v-if="careProperties.length">
                <section class="descriptionContainer"
                  v-for="vProperty in careProperties"
                  :key="vProperty.id">
                  <button class="btn btn-block text-left descriptionButton collapsed" data-toggle="collapse"
                    data-target="#careTaking" aria-expanded="false" aria-controls="careTaking"
                    aria-label="Pflegehinweise" click-count>
                    <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="1.5" fill="none"
                      stroke-linecap="round" stroke-linejoin="round" class="icon-care">
                      <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
                    </svg>
                    <span v-html="$translate('biokinderDesign::Template.itemCareAndUse')"></span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-plus">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </button>
                  <div id="careTaking" class="collapse" aria-labelledby="more_details" data-parent="#rightSide">
                    <div class="descriptionContent" v-html="vProperty.values.value"></div>
                    <template v-if="$attrs.availabilitydata.ourFurniture && (color1 !== null || color2 !== null)">
                      <div class="row">
                        <div class="col-6" v-for="careSet in availableCareSets">
                          <a :href="careSet.url" class="careSet">
                            <img :src="careSet.image" :alt="'Pflegeset ' + careSet.name" />
                            {{ careSet.name }}
                          </a>
                        </div>
                      </div>
                    </template>
                  </div>
                </section>
              </template>

              <!-- Support -->
              <section class="descriptionContainer">
                <button class="btn btn-block text-left descriptionButton collapsed" data-toggle="collapse"
                  data-target="#supportBox" aria-expanded="false" aria-controls="supportBox"
                  aria-label="Sie haben Fragen?" click-count>
                  <i data-feather="help-circle" class="icon-care"></i>
                  <span v-html="'Sie haben Fragen?'"></span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="feather feather-plus">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
                <div id="supportBox" class="collapse" aria-labelledby="more_details" data-parent="#rightSide">
                  <div class="descriptionContent">
                    <p>Wir helfen Ihnen gerne! Rufen Sie uns an oder schreiben Sie uns eine Nachricht. Wir stehen Ihnen
                      Montags bis Freitags von 9:00 bis 15:00 Uhr zur Verfügung und beraten Sie gerne.</p>
                    <div class="contactBox">
                      <p>
                        <a id="phoneNumberLink" href="tel:+4960814456315">+49 (0) 6081 - 44 563 15</a>
                      </p>
                      <span>Mo. - Fr., 9:00 - 14:00 Uhr</span>
                    </div>

                    <form class="row" id="12fd" method="post"
                      @submit.prevent="$store.dispatch('sendContactForm', $event)">
                      <input type="hidden" data-mail="recipient" value="info@bio-kinder.de" />
                      <input type="hidden" data-mail="subject" value="Frage zu Produkt" />
                      <div class="col-12 cmp-contact">
                        <div class="input-unit mb-1 required" data-validate="text">
                          <input name="name12" type="text" id="name12">
                          <label for="name12">
                            Name *
                          </label>
                        </div>
                        <div class="widget-mail-input">
                          <div class="input-unit mb-1 required" data-validate="mail">
                            <input name="mail12" type="email" id="mail12">
                            <input type="hidden" data-mail="reply-to-address" value="mail12">
                            <label for="mail12">
                              Ihre E-Mail Adrresse *
                            </label>
                          </div>
                        </div>
                        <div class="input-unit">
                          <input name="product" disabled="disabled" type="text"
                            :value="currentVariation.item.id + '-' + currentVariation.variation.id + ' ' + currentVariation.texts.name1"
                            id="product">
                          <label for="product">
                            Produkt
                          </label>
                        </div>
                        <div class="input-unit mb-1 required textarea" data-validate="text">
                          <textarea name="text12" id="text12" rows="4" class="no-resize"></textarea>
                          <label for="text12">
                            Ihre Anfrage *
                          </label>
                        </div>
                      </div>
                      <input class="honey" type="text" name="username" autocomplete="new-password" tabindex="-1">
                      <div class="col-12 text-right">
                        <recaptcha :deferred="true"></recaptcha>
                        <input type="submit" value="Anfrage senden" class="btn btn-bkm btn-sm btn-send-contact-form" />
                      </div>
                    </form>

                  </div>
                </div>
              </section>

              <!-- <section class="eu-garant descriptionContainer">
                <guarantee-label class="m-0" :item-data="currentVariation"></guarantee-label>
              </section> -->
            </aside>
          </div><!-- row close -->

          <!-- beaver content -->
          <slot name="additional-beaver-content"></slot>

          <!-- Central catalogue videos stay independent of theme templates. -->
          <video-management-item-slider :item-id="itemId"></video-management-item-slider>

          <!-- size guide tables and chairs -->
          <slot v-if="showChairTableSizeGuide" name="table-chair-size-guide"></slot>

          <div class="row">
            <div class="col-12">
              <slot name="item-list-container"></slot>
              <slot name="series-slide"></slot>
              <variation-cross-selling
                :cross-selling-ids="variationCrossSellingIds"
                :decimal-count="crossSellingDecimalCount">
              </variation-cross-selling>
            </div>
          </div>
          <div class="row">
            <div ref="feedbackTrigger" data-feedback class="widget col-12">
              <template v-if="isFeedbackActive">
                <slot name="feedback-container"></slot>
              </template>
              <div v-else class="feedback-deferred-trigger" style="min-height: 1px;" aria-hidden="true"></div>
            </div>
          </div>
        </div> <!-- ./container max -->

      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined, isNullOrUndefinedOrEmpty } from "../../helper/utils";
import { mapState } from "vuex";
import AsyncItemListLoader from "./AsyncItemListLoader.vue";
import SingleItemBundleDetails from "./SingleItemBundleDetails.vue";
import VariationCrossSelling from "./VariationCrossSelling.vue";

export default {

    name: "single-item",

    components: {
        AsyncItemListLoader,
        SingleItemBundleDetails,
        VariationCrossSelling
    },

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        hasAccessoryCrossSelling: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object,
        crossSellingDecimalCount: {
            type: Number,
            default: 0
        },
        videoManagementManifest: {
            type: Object,
            default: () => ({})
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    data()
    {
        return {
            isFeedbackActive: false
        };
    },

    computed:
    {
        itemConfig()
        {
            return App.config.item.itemData;
        },

        bkconfig()
        {
          return App.bkconfig;
        },

        variationCrossSellingIds()
        {
            return this.getVariationIdsFromProperty(293);
        },

        cartCrossSellingIds()
        {
            return this.getVariationIdsFromProperty(246);
        },

        crossSellingCategoryId()
        {
            let prop = this.getProperty(292)[0] ?? null;

            if(!prop)
              return 0;

            if(!prop.values?.selectionId)
              return 0;
            
            let value = prop?.values?.value ?? "Abc #0";
            let categoryId = value.includes("#") ? value.split("#")[1] : "0";
            return isNaN(parseInt(categoryId)) ? 0 : parseInt(categoryId);
        },

        reducedPrice()
        {
            if(!this.currentVariation.prices || !this.currentVariation.prices.default || !this.currentVariation.prices.rrp)
              return false;

            if (this.currentVariation.prices.rrp === null || this.currentVariation.prices.default === null)
              return false;

            if (this.currentVariation.prices.default.price.value >= this.currentVariation.prices.rrp.price.value)
              return false;
            
            return (this.currentVariation.prices.default.price.value <  this.currentVariation.prices.rrp.price.value);
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        propertyIndex()
        {
            const propertiesById = Object.create(null);
            const propertySelectionIdsById = Object.create(null);
            const propertyGroupsById = Object.create(null);
            const variationProperties = this.currentVariation?.variationProperties;

            if (!Array.isArray(variationProperties))
            {
                return {
                    propertiesById,
                    propertySelectionIdsById,
                    propertyGroupsById
                };
            }

            for (const group of variationProperties)
            {
                if (!group || typeof group.id === "undefined")
                {
                    continue;
                }

                propertyGroupsById[group.id] = group;

                if (!Array.isArray(group.properties))
                {
                    continue;
                }

                for (const property of group.properties)
                {
                    if (!property || typeof property.id === "undefined")
                    {
                        continue;
                    }

                    propertiesById[property.id] = property;

                    if (Array.isArray(property.values))
                    {
                        propertySelectionIdsById[property.id] = new Set(
                            property.values
                                .map(value => parseInt(value?.selectionId, 10))
                                .filter(value => !Number.isNaN(value))
                        );
                    }
                }
            }

            return {
                propertiesById,
                propertySelectionIdsById,
                propertyGroupsById
            };
        },

        propertyGroup4()
        {
            return this.propertyIndex.propertyGroupsById[4]?.properties || [];
        },

        careProperties()
        {
            return this.propertyGroup4.filter(property => property.id === 191);
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        },
        showBundleComponents()
        {
            return (this.hasProperty(235) && this.currentVariation.variation.bundleType === 'bundle')
        },
        showChairTableSizeGuide() {
          // Check if any of the values are included in the array
          if(!this.currentVariation.tags || this.currentVariation.tags.length <= 0)
            return false;

          return this.currentVariation.tags.some(tag => [130, 131, 132, 133].includes(tag.id));
        },
        hasFixedPrice() {
            return this.currentVariation?.tags?.some(tag => tag.id === 8) || false;
        },  
        color1() {
            const valueId = this.getFurnitureColor(3); // Front
            const valueMap = {
                119: 'alder',
                110: 'white',
                802: 'gray',
                803: 'rose',
                109: 'lilac',
                107: 'green',
                90: 'blue'
            };
            return valueMap[valueId] || null;
        },
        color2() {
            const valueId = this.getFurnitureColor(9); // Korpus
            const valueMap = {
                804: 'alder',
                806: 'white',
                816: 'gray'
            };
            return valueMap[valueId] || null;
        },
        availableCareSets() { 
            let retVal = [];
            
            if (this.color1 !== null && this.getCareData(this.color1) !== null)
                retVal.push(this.getCareData(this.color1))
            if (this.color2 !== null && this.getCareData(this.color2) !== null && this.color1 != this.color2)
                retVal.push(this.getCareData(this.color2))
            return retVal;
        },
        calcDefaultShippingCosts() {
          return this.$attrs.atshippingcost !== ""
            ? parseFloat(this.$attrs.atshippingcost)
            : this.currentVariation.variation.defaultShippingCosts;          
        },
        techProperties()
        {
          let returnProperties = [];
          let hiddenProperties = [166, 246, 191, 197, 192, 235, 282, 290, 292, 293, 296];

          if (!this.propertyGroup4.length)
          {
            return returnProperties;
          }

          for (const property of this.propertyGroup4)
          {
            if(hiddenProperties.includes(property.id))
            {
              continue;
            }
            
            if (!property.values.value || property.values.value === null || property.values.value.trim() == "")
            {
              continue;
            }

            returnProperties.push({
              name: property.names.name,
              value: property.values.value.trim()
            });
          }
          return returnProperties;
        },
        cubeConfigLink()
        {
          let prop = this.getProperty(296);
          if(prop.length > 0 && prop[0].values.value !== "")
            return `/laura/${prop[0].values.value}/`;
          return null;
        },
        itemsCouponDisabled()
        {
          if(this.bkconfig.shopSale.itemsCouponDisabled)
            return this.bkconfig.shopSale.itemsCouponDisabled.split(",").map(elem => { 
              let lmnt = elem.trim(); 
              return parseInt(lmnt, 10); 
            });
        },
        showResponsible()
        {
          return (typeof this.currentVariation.item.manufacturer.responsibleName !== undefined &&
                  this.currentVariation.item.manufacturer.responsibleName !== null && 
                  this.currentVariation.item.manufacturer.responsibleName !== "");
        },
        showManufacturer()
        {
          return (this.currentVariation.item.manufacturer.id && this.currentVariation.item.manufacturer.logo);
        },
        hasCartCrossSelling()
        {
          return this.cartCrossSellingIds.length > 0;
        },
        showSalesCoupon()
        {
          const shopSale = this.bkconfig && this.bkconfig.shopSale
          const item = this.currentVariation && this.currentVariation.item
          const tags = this.currentVariation && this.currentVariation.tags
          if (!shopSale || !item) return false

          // supports tags like [{id:8}, ...] or [{tag:{id:8}}, ...]
          const hasTag8 = Array.isArray(tags) &&
            tags.some(t => (t && (t.id === 8)))

          return (
            (!this.reducedPrice && shopSale.showItemPage == "true") &&
            (shopSale.itemPageMode == 0 ||
              (shopSale.itemPageMode == 1 && item.manufacturer && item.manufacturer.id == 17)) &&
            !this.itemsCouponDisabled.includes(item.id) &&
            !this.hasFixedPrice &&
            !hasTag8
          );
        },
        freightType()
        {
            const selectionId = this.getProperty(329)[0]?.values?.selectionId;

            if (selectionId === 1337 || selectionId === "1337")
            {
                return 1;
            }

            if (selectionId === 1338 || selectionId === "1338")
            {
                return 2;
            }

            return 0;
        },
        ...mapState({
          shippingCountryId: state => state.basket.data.shippingCountryId
        }),
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData).then(() =>
        {
            this.$store.commit(`${this.itemId}/mergeVideoManagementManifest`, this.videoManagementManifest);
        });
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
        
        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
            itemId:             this.itemId,
            attributes:         this.attributesData,
            variations:         this.variations,
            initialVariationId: this.currentVariation.variation.id,
            isPleaseSelectOption: this.initPleaseSelectOption,
            afterKey:           this.afterKey
        });
    },

    mounted()
    {
        this.$nextTick(() =>
        {

            if (this.isItemSet)
            {
                this.$store.dispatch("initSetComponents", this.itemData);
            }
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
        this.observeFeedbackVisibility();
    },

    beforeDestroy()
    {
        this.disconnectFeedbackObserver();
    },

    methods:
    {
        observeFeedbackVisibility()
        {
            if (this.isFeedbackActive)
            {
                return;
            }

            if (typeof window === "undefined" || typeof IntersectionObserver === "undefined")
            {
                this.activateFeedback();
                return;
            }

            this.$nextTick(() =>
            {
                if (this.isFeedbackActive || !this.$refs.feedbackTrigger)
                {
                    return;
                }

                this.disconnectFeedbackObserver();
                this.feedbackVisibilityObserver = new IntersectionObserver(entries =>
                {
                    if (entries.some(entry => entry.isIntersecting))
                    {
                        this.activateFeedback();
                    }
                }, {
                    rootMargin: "0px 0px 400px 0px",
                    threshold: 0
                });
                this.feedbackVisibilityObserver.observe(this.$refs.feedbackTrigger);
            });
        },

        activateFeedback()
        {
            if (this.isFeedbackActive)
            {
                return;
            }

            this.isFeedbackActive = true;
            this.disconnectFeedbackObserver();
        },

        disconnectFeedbackObserver()
        {
            if (this.feedbackVisibilityObserver)
            {
                this.feedbackVisibilityObserver.disconnect();
                this.feedbackVisibilityObserver = null;
            }
        },

        getVariationIdsFromProperty(propertyId)
        {
            const property = this.getProperty(propertyId)[0] ?? null;
            const rawValue = property?.values?.value;

            if (typeof rawValue !== "string")
            {
                return [];
            }

            return [...new Set(
                rawValue
                    .split(",")
                    .map(value => parseInt(value.trim(), 10))
                    .filter(value => value > 0)
            )];
        },

        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        hasProperty(propertyId) {
            return !!this.propertyIndex.propertiesById[propertyId];
        },

        getProperty(propertyId) { // returns array with one element
            const property = this.propertyIndex.propertiesById[propertyId];

            return property ? [property] : [];
        },

        hasPropertySelection(propertyId, propertySelectionId)
        {
            const selectionIds = this.propertyIndex.propertySelectionIdsById[propertyId];
            const normalizedSelectionId = parseInt(propertySelectionId, 10);

            return !!selectionIds && !Number.isNaN(normalizedSelectionId) && selectionIds.has(normalizedSelectionId);
        },
        getFurnitureColor(attributeId) {
            if (this.currentVariation.attributes.length == 0)
                return null;

            for (const item of this.currentVariation.attributes) {
                if (item.attributeId == attributeId) {
                    return item.valueId;
                }
            }
            return null;
        },
        getCareData(colorString)
        {
            let dataMap = {
                'alder': {
                    'name': 'bioola® nature Pflegeset',
                    'url': '/bioola-pflegeset-naturholz_22505_17402/',
                    'image': 'https://cdn.bio-kinder.de/item/images/22505/secondPreview/22505-bioola---nature-Pflegeset-Naturholz-27900-16802-bioola-Leinoel-Firnis-Pflegeset.jpg'
                },
                'white': {
                    'name': 'bioola® colour Pflegeset',
                    'url': '/bioola-pflegeset-lasur_22506_17407/',
                    'image': 'https://cdn.bio-kinder.de/item/images/22506/secondPreview/22506-bioola---Pflegeset-Lasur-Pflegeset-Naturweiss-web.jpg'
                },
                'gray': {
                    'name': 'bioola® colour Pflegeset',
                    'url': '/bioola-pflegeset-lasur_22506_17408/',
                    'image': 'https://cdn.bio-kinder.de/item/images/22506/secondPreview/22506-bioola---Pflegeset-Lasur-Pflegeset-Elefantengrau-web.jpg'
                },
                'rose': {
                    'name': 'bioola® colour Pflegeset',
                    'url': '/bioola-pflegeset-lasur_22506_17409/',
                    'image': 'https://cdn.bio-kinder.de/item/images/22506/secondPreview/22506-bioola---Pflegeset-Lasur-Pflegeset-Steinrose-web.jpg'
                },
                'lilac': {
                    'name': 'bioola® colour Pflegeset',
                    'url': '/bioola-pflegeset-lasur_22506_17406/',
                    'image': 'https://cdn.bio-kinder.de/item/images/22506/secondPreview/22506-bioola---Pflegeset-Lasur-Pflegeset-Flieder-web.jpg'
                },
                'green': {
                    'name': 'bioola® colour Pflegeset',
                    'url': '/bioola-pflegeset-lasur_22506_17404/',
                    'image': 'https://cdn.bio-kinder.de/item/images/22506/secondPreview/22506-bioola---Pflegeset-Lasur-Pflegeset-Ozeanblau-web.jpg'
                }
            };
            return dataMap[colorString] ?? null;
        },
        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
